export { default } from "./InfoBox";
